<template>
  <div>
    <h2>404 Not Found</h2>
    <p>
      The page you are looking for doesn't exist.
      If you believe this is an error, send us a note with the URL you
      are trying to access to our <a href="https://www.donedone.com/help-center">Support Center</a>.
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'NotFound',
})
</script>
